import { useMemo, useState } from "react";

export function ExportMenu({
  buttonLabel = "Export CSV",
  disabled = false,
  items = [],
  title = "Choose CSV export"
}) {
  const availableItems = useMemo(() => items.filter(Boolean), [items]);
  const [open, setOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(availableItems[0]?.key || "");
  const selectedItem = availableItems.find((item) => item.key === selectedKey) || availableItems[0];
  const busy = availableItems.some((item) => item.busy);
  const menuDisabled = disabled || availableItems.length === 0;

  function openMenu() {
    setSelectedKey((current) => current || availableItems[0]?.key || "");
    setOpen((current) => !current);
  }

  function downloadSelected() {
    if (!selectedItem || selectedItem.disabled || selectedItem.busy) {
      return;
    }
    selectedItem.onExport?.();
    setOpen(false);
  }

  return (
    <div className="export-menu">
      <button
        type="button"
        className="secondary-button"
        disabled={menuDisabled || busy}
        onClick={openMenu}
      >
        {busy ? "Exporting..." : buttonLabel}
      </button>
      {open && (
        <div className="export-menu-panel" role="dialog" aria-label={title}>
          <div>
            <strong>{title}</strong>
            <button type="button" className="secondary-button" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
          <label>
            What do you want to download?
            <select value={selectedItem?.key || ""} onChange={(event) => setSelectedKey(event.target.value)}>
              {availableItems.map((item) => (
                <option key={item.key} value={item.key} disabled={item.disabled}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
          {selectedItem?.description && <p>{selectedItem.description}</p>}
          <button
            type="button"
            disabled={!selectedItem || selectedItem.disabled || selectedItem.busy}
            onClick={downloadSelected}
          >
            {selectedItem?.busy ? "Exporting..." : "Download CSV"}
          </button>
        </div>
      )}
    </div>
  );
}
